module.exports = __webpack_public_path__ + "media/P.1ff93a94.mp3";